import React from "react";
import SlideInOutAnimation from "../../util/SlideInOutAnimation";
import CsvBuddyLogo from "../../assets/logo/csvbuddy-logo.png";
import PgLife from "../../assets/logo/pglife-logo.png";
import FormFlexLogo from "../../assets/logo/formflex-logo.svg";
import CogniQuizLogo from "../../assets/logo/cogniquiz-logo.png";
import FalwalaLogo from "../../assets/logo/falwala-logo.png";
import TicTacToeLogo from "../../assets/logo/tictactoe-logo.png";
import { FaExternalLinkAlt } from "react-icons/fa";

function Portfolio() {
  const projects = [
    {
      name: "CsvBuddy",
      logo: CsvBuddyLogo,
      link: "https://csvbuddy.netlify.app/",
    },
    {
      name: "Form Flex",
      logo: FormFlexLogo,
      link: "https://formflex.netlify.app/home",
    },
    { name: "PG Life", logo: PgLife, link: "https://pg-life.netlify.app/" },
    {
      name: "CogniQuiz",
      logo: CogniQuizLogo,
      link: "https://cognisolver.github.io/cogni-quiz/",
    },
    {
      name: "Falwala",
      logo: FalwalaLogo,
      link: "https://cognisolver.github.io/falwala/"
    },
    {
      name: "Tic Tac Toe",
      logo: TicTacToeLogo,
      link: "https://cognisolver.github.io/tic-tac-toe/",
    },
  ];

  return (
    <section className="px-6 py-16 text-center">
      <SlideInOutAnimation>
        <h2 className="text-4xl font-bold mb-10">
          MY <span className="text-yellow-500">PROJECTS</span>
        </h2>
      </SlideInOutAnimation>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:px-20">
        {projects.map((project, idx) => (
          <SlideInOutAnimation
            key={idx}
            className="relative bg-gray-800 h-48 flex flex-col items-center justify-center"
          >
            <a
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="absolute top-2 right-2"
            >
              <FaExternalLinkAlt className="text-gray-500" />
            </a>

            <img
              src={project.logo}
              alt={project.name}
              className="h-36 w-36 object-contain transition-transform duration-300 hover:scale-110"
            />
            <p className="text-xl font-bold">{project.name}</p>
          </SlideInOutAnimation>
        ))}
      </div>
    </section>
  );
}

export default Portfolio;
